import React, { useState } from 'react';
import { useForm } from '@formspree/react';

const ContactForm = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [formState, handleSubmit] = useForm('xjvlywql');

  return (
    <form id="landing-contact" onSubmit={handleSubmit}>
      <label htmlFor="contact-name">Name</label>
      <input
        id="contact-name"
        type="text"
        value={name}
        name="name"
        required
        onChange={(e) => setName(e.target.value)}
      />
      <label htmlFor="contact-email">Email</label>
      <input
        id="contact-email"
        type="email"
        value={email}
        name="email"
        required
        onChange={(e) => setEmail(e.target.value)}
      />
      <label htmlFor="contact-message">Message</label>
      <textarea
        id="contact-message"
        value={message}
        name="message"
        onChange={(e) => setMessage(e.target.value)}
      />
      {formState.succeeded && (
        <p className="contact-response">
          Thank you for contacting us! Please check your inbox in 24hrs. Looking forward to working
          with you :)
        </p>
      )}
      {formState.submitting && <p className="contact-response">Submitting form...</p>}
      {formState.errors.length > 0 && (
        <p className="contact-response">{formState.errors[0].message}</p>
      )}
      <button type="submit" id="contact-btn" disabled={formState.submitting}>
        Submit
      </button>
    </form>
  );
};

class LandingContact extends React.Component {
  render() {
    return (
      <div className="width-limit">
        <p id="landing-contact-text">
          Please fill out the below form.
          <br />
          Our team will get in touch with you within 24hrs to start the process.
        </p>
        <ContactForm />
      </div>
    );
  }
}

export default LandingContact;
